import { getAsyncCurrentUser } from ".";
import { Roles } from "./authTypes";

export const hasACKPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return roleInCurrentFactory !== Roles.GLOBALVIEWER;
};

export const hasRemoteDesktopPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return roleInCurrentFactory !== Roles.GLOBALVIEWER;
};

export const hasConfigPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return roleInCurrentFactory === Roles.ADMIN;
};

export const hasControlPanelPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return [Roles.ADMIN, Roles.LC].includes(roleInCurrentFactory);
};

export const hasControlPanelEditPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return roleInCurrentFactory === Roles.ADMIN;
};

const rolesWithSwitchAndLastBatchPermission = [Roles.ADMIN, Roles.LC];
export const hasSwitchPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return rolesWithSwitchAndLastBatchPermission.includes(roleInCurrentFactory);
};

export const hasLastBatchPermission = async () => {
  const { roleInCurrentFactory } = await getAsyncCurrentUser();
  return rolesWithSwitchAndLastBatchPermission.includes(roleInCurrentFactory);
};
